import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { 
  FaHome,
  FaSearch,
  FaFilter,
  FaCalendarAlt,
  FaStar,
  FaFlag,
  FaSun,
  FaMoon,
  FaLeaf,
  FaGift,
  FaGraduationCap,
  FaBook,
  FaClock,
  FaSchool,
  FaUsers,
  FaChild,
  FaTree,
  FaFire,
  FaCloudSun,
  FaSnowman,
  FaUmbrella,
  FaWind,
  FaMedal,
  FaTrophy,
  FaMusic,
  FaPalette,
  FaFutbol,
  FaChalkboardTeacher,
  FaUserTie,
  FaFlask
} from 'react-icons/fa';
import { title as siteTitle } from '../constants/constant';
import Layout from '../components/layout/Layout';
import BreadcrumbImg from '../assets/images/breadcrumb.png';

// Constants Data
const breadcrumbData = {
  home: { text: "Home", path: "/" },
  current: "Calendar",
  title: "Academic Calendar 2026",
  image: BreadcrumbImg
};

const statsData = [
  { id: 1, value: "12", label: "Months", color: "text-gray-900" },
  { id: 2, value: "24", label: "Holidays", color: "text-red-600" },
  { id: 3, value: "18", label: "Exams", color: "text-blue-600" },
  { id: 4, value: "15", label: "Events", color: "text-green-600" },
  { id: 5, value: "3", label: "Terms", color: "text-purple-600" },
  { id: 6, value: "57", label: "Total Days", color: "text-amber-600" }
];

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const eventTypes = [
  { id: "all", label: "All Events", color: "bg-gray-100 text-gray-800" },
  { id: "holiday", label: "Holidays", color: "bg-red-100 text-red-700" },
  { id: "academic", label: "Academic", color: "bg-blue-100 text-blue-700" },
  { id: "event", label: "Events", color: "bg-green-100 text-green-700" }
];

const eventsData = [
  {
    id: 1,
    month: "January",
    year: 2026,
    events: [
      { day: "1", type: "holiday", title: "New Year's Day", icon: FaStar },
      { day: "14", type: "holiday", title: "Makar Sankranti", icon: FaSun },
      { day: "15", type: "holiday", title: "Pongal", icon: FaLeaf },
      { day: "26", type: "holiday", title: "Republic Day", icon: FaFlag },
      { day: "27", type: "academic", title: "School Reopens", icon: FaSchool },
      { day: "28-31", type: "event", title: "Orientation", icon: FaUsers }
    ]
  },
  {
    id: 2,
    month: "February",
    year: 2026,
    events: [
      { day: "5", type: "holiday", title: "Vasant Panchami", icon: FaLeaf },
      { day: "14", type: "academic", title: "Mid-Term Exams", icon: FaBook },
      { day: "16-20", type: "event", title: "Science Exhibition", icon: FaFlask },
      { day: "25", type: "academic", title: "Exams End", icon: FaClock },
      { day: "26", type: "academic", title: "Results", icon: FaGraduationCap }
    ]
  },
  {
    id: 3,
    month: "March",
    year: 2026,
    events: [
      { day: "8", type: "holiday", title: "Holi", icon: FaFire },
      { day: "10", type: "event", title: "Sports Day", icon: FaFutbol },
      { day: "17", type: "event", title: "PT Meeting", icon: FaUsers },
      { day: "25", type: "event", title: "Annual Day Prep", icon: FaMusic },
      { day: "30", type: "holiday", title: "Summer Break", icon: FaSun }
    ]
  },
  {
    id: 4,
    month: "April",
    year: 2026,
    events: [
      { day: "2", type: "holiday", title: "Good Friday", icon: FaStar },
      { day: "14", type: "holiday", title: "Ambedkar Jayanti", icon: FaUserTie },
      { day: "15", type: "holiday", title: "Bohag Bihu", icon: FaLeaf },
      { day: "21", type: "event", title: "Summer Camp", icon: FaChild },
      { day: "30", type: "event", title: "Camp Ends", icon: FaFlag }
    ]
  },
  {
    id: 5,
    month: "May",
    year: 2026,
    events: [
      { day: "1", type: "holiday", title: "Labour Day", icon: FaUsers },
      { day: "5", type: "holiday", title: "Buddha Purnima", icon: FaStar },
      { day: "20", type: "academic", title: "School Reopens", icon: FaSchool },
      { day: "25-30", type: "academic", title: "Unit Test I", icon: FaBook }
    ]
  },
  {
    id: 6,
    month: "June",
    year: 2026,
    events: [
      { day: "5", type: "event", title: "Environment Day", icon: FaTree },
      { day: "21", type: "event", title: "Yoga Day", icon: FaChild },
      { day: "25-30", type: "academic", title: "Project Week", icon: FaBook },
      { day: "30", type: "event", title: "PTA Meeting", icon: FaUsers }
    ]
  },
  {
    id: 7,
    month: "July",
    year: 2026,
    events: [
      { day: "17", type: "holiday", title: "Bakrid", icon: FaStar },
      { day: "20-25", type: "academic", title: "Mid-Year Exams", icon: FaBook },
      { day: "27", type: "event", title: "Guru Purnima", icon: FaUserTie },
      { day: "30", type: "academic", title: "Results", icon: FaGraduationCap }
    ]
  },
  {
    id: 8,
    month: "August",
    year: 2026,
    events: [
      { day: "15", type: "holiday", title: "Independence Day", icon: FaFlag },
      { day: "19", type: "holiday", title: "Janmashtami", icon: FaStar },
      { day: "20-25", type: "event", title: "Inter-School Comp", icon: FaTrophy },
      { day: "30", type: "event", title: "Rakhi Celebration", icon: FaGift }
    ]
  },
  {
    id: 9,
    month: "September",
    year: 2026,
    events: [
      { day: "5", type: "event", title: "Teacher's Day", icon: FaChalkboardTeacher },
      { day: "10", type: "holiday", title: "Ganesh Chaturthi", icon: FaStar },
      { day: "15-20", type: "academic", title: "Unit Test II", icon: FaBook },
      { day: "25", type: "holiday", title: "Break Begins", icon: FaSun }
    ]
  },
  {
    id: 10,
    month: "October",
    year: 2026,
    events: [
      { day: "2", type: "holiday", title: "Gandhi Jayanti", icon: FaUserTie },
      { day: "8", type: "holiday", title: "Dussehra", icon: FaFire },
      { day: "12", type: "academic", title: "School Reopens", icon: FaSchool },
      { day: "20", type: "holiday", title: "Diwali Break", icon: FaStar },
      { day: "24", type: "holiday", title: "Diwali", icon: FaFire },
      { day: "29", type: "academic", title: "School Reopens", icon: FaSchool }
    ]
  },
  {
    id: 11,
    month: "November",
    year: 2026,
    events: [
      { day: "1", type: "academic", title: "Annual Prep", icon: FaBook },
      { day: "14", type: "event", title: "Children's Day", icon: FaChild },
      { day: "20-25", type: "academic", title: "Pre-Boards", icon: FaBook },
      { day: "30", type: "academic", title: "Last Day", icon: FaClock }
    ]
  },
  {
    id: 12,
    month: "December",
    year: 2026,
    events: [
      { day: "1-15", type: "academic", title: "Annual Exams", icon: FaBook },
      { day: "18", type: "academic", title: "Results", icon: FaGraduationCap },
      { day: "20", type: "event", title: "Prize Day", icon: FaTrophy },
      { day: "22", type: "holiday", title: "Winter Break", icon: FaSnowman },
      { day: "25", type: "holiday", title: "Christmas", icon: FaStar }
    ]
  }
];

const keyDatesData = [
  { title: "Academic Year Begins", date: "Jan 27, 2026", type: "academic" },
  { title: "Summer Vacation", date: "Mar 30 - May 19", type: "holiday" },
  { title: "Diwali Break", date: "Oct 20 - 28", type: "holiday" },
  { title: "Annual Exams", date: "Dec 1-15", type: "academic" },
  { title: "Winter Vacation", date: "Dec 22 - Jan 26", type: "holiday" },
  { title: "School Timing", date: "8:30 AM - 2:30 PM", type: "info" }
];

const typeColors = {
  holiday: "bg-red-100 text-red-700",
  academic: "bg-blue-100 text-blue-700",
  event: "bg-green-100 text-green-700",
  info: "bg-gray-100 text-gray-700"
};

const typeDots = {
  holiday: "bg-red-500",
  academic: "bg-blue-500",
  event: "bg-green-500"
};

export default function Calendar() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [selectedType, setSelectedType] = useState("all");

  const filteredEvents = eventsData.filter(monthData => {
    const matchesMonth = selectedMonth === "all" || monthData.month === selectedMonth;
    const matchesSearch = monthData.events.some(event => 
      event.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return matchesMonth && (searchQuery === "" || matchesSearch);
  });

  return (
    <Layout>
      <Helmet>
        <title>Academic Calendar | {siteTitle}</title>
        <meta name="description" content="View the academic calendar for Gyan Rashmi including holidays, exam schedules, events, and important dates for the year 2026." />
      </Helmet>

      {/* Breadcrumb Section */}
      <div className="relative bg-gray-900">
        <div className="h-40 md:h-48">
          <img 
            alt="Breadcrumb" 
            className="object-cover w-full h-full opacity-60" 
            src={breadcrumbData.image} 
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <div className="flex items-center mb-2 text-sm text-white">
            <a 
              href={breadcrumbData.home.path} 
              className="flex items-center transition-colors hover:text-gray-200"
            >
              <FaHome className="w-3 h-3 mr-1.5" />
              {breadcrumbData.home.text}
            </a>
            <span className="mx-2">/</span>
            <span className="font-semibold">{breadcrumbData.current}</span>
          </div>
          <h1 className="text-2xl font-bold text-white md:text-3xl">{breadcrumbData.title}</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="container px-3 py-5 mx-auto max-w-7xl md:px-4 md:py-6">
        {/* Stats Cards */}
        <div className="grid grid-cols-3 gap-2 mb-5 md:grid-cols-6">
          {statsData.map((stat) => (
            <div key={stat.id} className="p-2 text-center bg-white border border-gray-200 rounded-lg">
              <div className={`text-base font-bold md:text-lg ${stat.color}`}>{stat.value}</div>
              <div className="text-[10px] text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Search and Filter Bar */}
        <div className="p-3 mb-5 bg-white border border-gray-200 rounded-xl">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            {/* Search */}
            <div className="relative flex-1">
              <FaSearch className="absolute w-3.5 h-3.5 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
              <input 
                placeholder="Search events..." 
                className="w-full py-1.5 pl-8 pr-3 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            {/* Month Filter */}
            <div className="flex items-center gap-2">
              <FaFilter className="w-3.5 h-3.5 text-gray-600" />
              <select 
                className="px-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                <option value="all">All Months</option>
                {months.map(month => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
            </div>

            {/* Type Filter */}
            <div className="flex flex-wrap gap-1.5">
              {eventTypes.map((type) => (
                <button
                  key={type.id}
                  onClick={() => setSelectedType(type.id)}
                  className={`px-2.5 py-1 text-xs font-medium rounded-lg transition-colors ${
                    selectedType === type.id 
                      ? type.color 
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {type.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Month Tabs */}
        <div className="mb-5 overflow-x-auto">
          <div className="flex pb-2 space-x-1.5">
            <button
              onClick={() => setSelectedMonth("all")}
              className={`px-3 py-1.5 text-xs font-medium rounded-lg whitespace-nowrap ${
                selectedMonth === "all" 
                  ? 'bg-blue-600 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              All Months
            </button>
            {months.map((month) => (
              <button
                key={month}
                onClick={() => setSelectedMonth(month)}
                className={`px-3 py-1.5 text-xs font-medium rounded-lg whitespace-nowrap ${
                  selectedMonth === month 
                    ? 'bg-blue-600 text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {month.slice(0, 3)}
              </button>
            ))}
          </div>
        </div>

        {/* Events Grid */}
        <div className="grid gap-4 mb-6 md:grid-cols-2 lg:grid-cols-3">
          {filteredEvents.map((monthData) => (
            <div key={monthData.id} className="overflow-hidden transition-shadow bg-white border border-gray-200 shadow-sm rounded-xl hover:shadow-md">
              {/* Month Header */}
              <div className="p-3 border-b border-blue-200 bg-gradient-to-r from-blue-50 to-blue-100">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-bold text-gray-900">{monthData.month} {monthData.year}</h3>
                  <span className="px-1.5 py-0.5 text-[10px] font-medium text-blue-700 bg-white rounded-lg">
                    {monthData.events.length} events
                  </span>
                </div>
              </div>

              {/* Events List */}
              <div className="p-3">
                <div className="space-y-2">
                  {monthData.events.map((event, idx) => (
                    <div key={idx} className={`flex items-start gap-2 p-2 rounded-lg border ${
                      event.type === 'holiday' ? 'bg-red-50 border-red-200' :
                      event.type === 'academic' ? 'bg-blue-50 border-blue-200' :
                      'bg-green-50 border-green-200'
                    }`}>
                      <div className={`flex-shrink-0 w-6 h-6 rounded-lg flex items-center justify-center ${
                        event.type === 'holiday' ? 'bg-red-100 text-red-700' :
                        event.type === 'academic' ? 'bg-blue-100 text-blue-700' :
                        'bg-green-100 text-green-700'
                      }`}>
                        <event.icon className="w-3 h-3" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-1.5 mb-0.5">
                          <span className="text-xs font-bold text-gray-900">{event.day}</span>
                          <span className={`text-[8px] font-semibold px-1 py-0.5 rounded-full ${
                            event.type === 'holiday' ? 'bg-red-200 text-red-700' :
                            event.type === 'academic' ? 'bg-blue-200 text-blue-700' :
                            'bg-green-200 text-green-700'
                          }`}>
                            {event.type === 'holiday' ? 'Holiday' :
                             event.type === 'academic' ? 'Academic' : 'Event'}
                          </span>
                        </div>
                        <p className="text-[10px] font-medium leading-tight text-gray-900">{event.title}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Key Dates Section */}
        <div className="p-4 mb-5 border border-blue-200 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl">
          <div className="flex items-center gap-2 mb-3">
            <FaCalendarAlt className="w-4 h-4 text-blue-600" />
            <h3 className="text-sm font-bold text-gray-900">Key Dates 2026</h3>
          </div>
          <div className="grid gap-2 md:grid-cols-2 lg:grid-cols-3">
            {keyDatesData.map((item, idx) => (
              <div key={idx} className="flex items-center justify-between p-2 bg-white border border-gray-200 rounded-lg">
                <div>
                  <p className="text-xs font-medium text-gray-900">{item.title}</p>
                  <p className="text-[10px] text-gray-600">{item.date}</p>
                </div>
                <span className={`text-[8px] font-semibold px-1.5 py-0.5 rounded-full ${typeColors[item.type]}`}>
                  {item.type === 'holiday' ? 'Holiday' :
                   item.type === 'academic' ? 'Academic' : 'Info'}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Event Types Legend */}
        <div className="p-3 mb-4 bg-white border border-gray-200 rounded-xl">
          <h4 className="mb-2 text-xs font-bold text-gray-900">Event Types</h4>
          <div className="grid grid-cols-3 gap-2">
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-red-500 rounded-full"></div>
              <span className="text-[10px] text-gray-700">Holidays</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-[10px] text-gray-700">Academic</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="text-[10px] text-gray-700">Events</span>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <div className="p-3 text-center border border-gray-200 bg-gray-50 rounded-xl">
          <p className="text-[10px] text-gray-600">
            * Dates are tentative and subject to change. Please check school notice board for updates.
          </p>
          <div className="inline-flex items-center gap-1.5 mt-1.5 px-2 py-1 bg-white border border-gray-300 rounded-full">
            <FaClock className="w-2.5 h-2.5 text-blue-600" />
            <span className="text-[8px] font-medium text-gray-900">Office: 8 AM - 4 PM</span>
          </div>
        </div>
      </div>
    </Layout>
  );
}